import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserModel } from '../../models/user.model';
import { environment } from '../../../../../environments/environment';
import { AuthModel } from '../../models/auth.model';
import { map } from 'rxjs/operators';
import { BaseResponse } from '@app/core/base';

const API_USERS_URL = `${environment.apiUrl}/login`;

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(private http: HttpClient) {}

  // public methods
  login(UserName: string, Password: string, TenantId: number): Observable<any> {
    return this.http.post<AuthModel>(`${API_USERS_URL}/login`, {
      UserName,
      Password,
      TenantId
    });
  }

  // CREATE =>  POST: add a new user to the server
  createUser(user: UserModel): Observable<UserModel> {
    return this.http.post<UserModel>(API_USERS_URL, user);
  }

  // Your server should check email => If email exists send link to the user and return true | If email doesn't exist return false
  forgotPassword(Email: string, Domain: string, TenantId: number): Observable<boolean> {
    return this.http.post<boolean>(`${environment.apiUrl}/user/ForgotPassword`, {
      Email,
      Domain,
      TenantId
    });
  }

  // Reset password using token sent by email
  resetPassword(Token: string, Password: string, ManagementOptions: number): Observable<boolean> {
    return this.http.post<boolean>(`${environment.apiUrl}/user/ResetPassword`, {
      Token,
      Password,
      ManagementOptions
    });
  }

  checkTokenForResetPassword(Token: string, ManagementOptions: number): Observable<any> {
    return this.http.post<boolean>(`${environment.apiUrl}/user/CheckTokenForResetPassword`, {
      Token,
      ManagementOptions
    });
  }

  getUserByToken(token: number): Observable<UserModel> {
    return this.http.get<BaseResponse<UserModel>>(`${environment.apiUrl}/user/user/GetUser/${token}`).pipe(map(response => response.result));
    // const httpHeaders = new HttpHeaders({
    //   Authorization: `Bearer ${token}`,
    // });
    // return this.http.get<UserModel>(`${API_USERS_URL}/me`, {
    //   headers: httpHeaders,
    // });
  }
}
